import type { FC } from 'react';
import { enUS } from 'date-fns/locale';
import { SingleDateCalendarRoot } from './AllieSingleDateCalendar.styles';
import type { AllieSingleDateCalendarProps } from './AllieSingleDateCalendar.types';
import {
  ReactDateRangeSingleCalendar,
} from './adapters/react-date-range/ReactDateRangeSingleCalendar';

export const AllieSingleDateCalendar: FC<AllieSingleDateCalendarProps> = ({
  value,
  onChange,
  locale,
  minDate,
  maxDate,
  className,
}) => (
  <SingleDateCalendarRoot data-allie-single-calendar className={className}>
    <ReactDateRangeSingleCalendar
      value={value}
      onChange={onChange}
      locale={locale ?? enUS}
      minDate={minDate}
      maxDate={maxDate}
    />
  </SingleDateCalendarRoot>
);

AllieSingleDateCalendar.displayName = 'AllieSingleDateCalendar';
